import React, { useState } from "react";
import {  //Box,LinearProgress,
  IconButton, Table, TableBody,
  TableCell, TableContainer, TableHead,
  TableRow, Card, Tooltip,
  TablePagination,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import XLSX from 'xlsx';
import PaginacionTab from "../layout/PaginacionTab";
import {numeroPag} from "../funciones/Paginacion";
import {findNumberCad} from '../funciones/FindNumber'
import SaveIcon from '@material-ui/icons/Save';
const useStyles = makeStyles({
  
  container: {
    //maxHeight: 550,
    maxHeight: window.innerHeight - 250,
    minHeight: 280,
    width: "91 rem",
  },
  container2: {
    maxHeight: 650,
    //maxHeight: window.innerHeight-170,
    //minHeight: 280,
  },
  tableRow: {
    "&$selected, &$selected:hover": {
      backgroundColor: process.env.REACT_APP_Color_Second,
    },
  },
  tableCell: {
    "$selected &": {
      color: "white",
    },
  },
  hover: {},
  selected: {},
});

const columnas = [
  { id: 1, titulo: "Fecha Registro", alinear: "center", },  
  { id: 2, titulo: "Tipo", alinear: "center", },  
  { id: 5, titulo: "Teléfono",alinear: "center",  },
  { id: 4, titulo: "Cargo",alinear: "center",  },
  
  { id: 13, titulo: "Lugar",alinear: "center",  },  
  { id: 9, titulo: "Nombre", alinear: "center",  },  
  { id: 11, titulo: "Otro", alinear: "center",  },
];

const TablaAsistencia = ({  listSuge, listExcel}) => {
  const classes = useStyles();
  let history = useHistory();
  const source = axios.CancelToken.source();
  const cadena = localStorage.getItem("Operacion")+"|"; 
  const usuID = localStorage.getItem('UsuId')?parseInt(localStorage.getItem('UsuId') ):0;
  const fondo =process.env.REACT_APP_Fondo_Color
  const tamMax = 100
  const [datos, guardarDatos] = useState([]);
  const [sinDatos, guardarSinDatos] = useState(true);
  const [espera, setEspera] = useState(false);
  const [selectedID, setSelectedID] = useState(null);
  const [totalPaginas, setTotalPaginas] = useState(0);
  const [numPagina, setNumPagina] = useState(0);
  const [listaExcel, setListaExcel] = useState([]);
  
  React.useEffect(() => {
    
    if (listSuge.length!==0 &&listSuge[0].Id!=="0" &&listSuge[0].Id!==0 ) {
      let arrM=[]
      numeroPag(listSuge, tamMax, setTotalPaginas, setNumPagina, guardarDatos)
      //guardarDatos(listSuge);  
      arrM.push(["Fecha Registro", "Tipo", "Teléfono", "Cargo", "Lugar", "Nombre", "Otro"])
      listSuge.forEach(element => {
        const auxFReg =
          moment.utc(element.Fch).format("YYYY-MM-DD HH:mm") === "1900-01-01 00:00"
          ? "" : moment.utc(element.Fch).format("DD/MM/YYYY HH:mm");
        arrM.push([auxFReg, element.Tipo, element.Tel, element.Cargo, element.Lugar, element.Nom, element.Otro])  
      });
      setListaExcel(arrM)
    }else{
      setListaExcel([])
      guardarDatos([]);
    }

    return () => { source.cancel() };
  }, [listSuge]);

  const exportarArch = () => {
    let today = new Date();                    
    let fec = moment(today);        
    //console.log(listaExcel);
    const ws = XLSX.utils.aoa_to_sheet(listaExcel);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reporte");
    XLSX.writeFile(wb, fec.format("YYMMDDHHmmss")+" Lista Asistencia.xlsx")
  }; 

  const seleccionado = (auxId) => {
    setSelectedID(auxId);
  };

  const celda = (alinear, estilo, contenido) => {
    return (
    <TableCell align={alinear} className={classes.tableCell}
      padding={"none"} style={estilo}
    >
      {contenido}
    </TableCell>
    );
  };

  const obtenerGen=(aux)=>{
    let respuesta=""
    switch (aux) {
      case 'H':
        respuesta="Hombre"
        break;
      case 'M':
        respuesta="Mujer"
        break;
      case 'X':
        respuesta="No Binario"
        break;
      case 'N':
        respuesta="Pendiente"
        break;
      default:
        break;
    }
    return respuesta
  }

  function Renglon(props) {
    const { row } = props;
    const auxFReg =
      moment.utc(row.Fch).format("YYYY-MM-DD HH:mm") === "1900-01-01 00:00"
        ? ""
        : moment.utc(row.Fch).format("DD/MM/YYYY HH:mm");
    return (    
    <TableRow
      //onClick={() => { seleccionado(row.Id, row) }}
      className={classes.tableRow} selected={selectedID === row.Id}
      classes={{ hover: classes.hover, selected: classes.selected }}
    >
      {celda("center", { width: "110px", fontSize: "12px", paddingRight: "2px" }, auxFReg )} 
      {celda("center",{ fontSize: "10px", paddingLeft: "8px",width:"40px" }, row.Tipo)}      
      {celda("center",{ fontSize: "10px", paddingLeft: "8px",width:"40px" }, row.Tel)}                          
      {celda( "left", { width: 160, fontSize: "12px", paddingLeft: "8px" }, row.Cargo)}
      
      {celda("left", { width: 140, fontSize: "12px", paddingLeft: "8px" }, row.Lugar)}           
      {celda( "left", { width: 240, fontSize: "12px", paddingLeft: "8px" }, row.Nom)}
      {celda( "left", { width: 100, fontSize: "12px", paddingLeft: "8px" }, row.Otro)}   
    </TableRow>  
    );
  }

  const vacia = (
    <TableCell className={classes.tableCell} align="center">
      {" "}
    </TableCell>
  );
  const ColumnaVacia = (
    <TableCell
      className={classes.tableCell}
      align="center"
      style={{ backgroundColor: fondo, color: "white" }}
    >
      {" "}
    </TableCell>
  );

  function tablaCompleta(auxlista) {
    return (
    <TableContainer className={classes.container}>
    <Table stickyHeader aria-label="sticky table">
      <TableHead>
        <TableRow>                     
          {columnas.map((row, index) => {
            const auxRow= index ===0? <span>
              {usuID===1 || findNumberCad('|36|',cadena) ?
              <IconButton onClick={exportarArch} size="small" >
                <Tooltip title="Exportar a Excel">
                  <SaveIcon style={{color:'white'}} fontSize="small" />
                </Tooltip>
              </IconButton>
              :null} 
              {` ${auxlista.length} ${row.titulo}`} </span> :row.titulo
            return (
            <TableCell
              style={{ backgroundColor: fondo, color: "white" }}
              key={row.titulo + row.id}  align={row.alinear}
              padding={"none"}
            >
              {auxRow} 
            </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
      <TableBody>
        {auxlista.length != 0
          ? auxlista.map((row) => (
              <Renglon key={"regPerfilGen" + row.Id} row={row} />
            ))
          : null}
      </TableBody>
    </Table>
    </TableContainer>
    );
  }

  function onChangePagina(event, newPage) {
    event.preventDefault();
    if (newPage === 0) {
        guardarDatos(listSuge.slice(0, tamMax))
    } else {
      guardarDatos(listSuge.slice(newPage * tamMax, newPage * tamMax + tamMax))
    }
    setNumPagina(newPage)
  }

  function generarFooter() {
    return (
    <TablePagination style={{padding:0}}
      rowsPerPageOptions={false} colSpan={3}
      rowsPerPage={tamMax} count={listSuge.length}
      page={numPagina} lang='es'
      labelDisplayedRows={
        ({from, to, count}) => {
          return '' + from + '-' + to + ' de ' + count
        }
      }
       onPageChange={onChangePagina}
      ActionsComponent={PaginacionTab}/>)
  }

  const tablaSinDatos = () => {
    return (
    <TableContainer className={classes.container2}>
    <Table stickyHeader aria-label="sticky table">
      <TableHead>
        <TableRow>              
          {columnas.map((row) => {
            return (
              <TableCell
                style={{ backgroundColor:fondo, color: "white" }}
                key={row.titulo + row.id}
                align={row.alinear}
                padding={"none"}
              >
                {row.titulo}
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow className={classes.tableRow}>
      
          <TableCell className={classes.tableCell} align="center">
            Sin{" "}
          </TableCell>
          {vacia}
        
          <TableCell className={classes.tableCell} align="center">
            Registros
          </TableCell>
          {vacia}
          {vacia}  
          {vacia}
             
        </TableRow>
      </TableBody>
    </Table>
    </TableContainer>
    );
  };

  const contenido = datos.length !== 0 ? tablaCompleta(datos) : tablaSinDatos();
  //const tabla = espera ?  (<Box pt={3}><LinearProgress/> </Box>) :( contenido )  

  const paginacion = !espera && datos.length !== 0 && totalPaginas > 1 ? generarFooter() : null;
  return (
  <div style={{ minWidth: 80 + "rem", maxWidth: 91 + "rem" }}>
    {paginacion}
    {contenido}
  </div>
  );
};

export default TablaAsistencia;
